import { render, staticRenderFns } from "./DynamicDepositFlow.vue?vue&type=template&id=5d478c8b&scoped=true"
import script from "./DynamicDepositFlow.vue?vue&type=script&lang=js"
export * from "./DynamicDepositFlow.vue?vue&type=script&lang=js"
import style0 from "./DynamicDepositFlow.vue?vue&type=style&index=0&id=5d478c8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d478c8b",
  null
  
)

export default component.exports